import { Box, SxProps, Theme, Typography } from '@mui/material';

import { AddressProps } from '@/models/Address';
import { ContactProps, ContactType } from '@/models/Contact';
import { UserType } from '@/models/User';

import { PrimaryContactSelect } from './PrimaryContactSelect';
import { ShippingAddressSection } from './ShippingAddressSection';
import { ProgramNames } from '@/models/Program';

type Props = {
  active: boolean;
  theme: Theme;
  userType: UserType | null;
  selectedContactId: number | null;
  contactOptions: ContactProps[];
  contactsLoading: boolean;
  shippingContact: ContactProps;
  shippingContactType?: ContactType;
  showErrors: boolean;
  shippingHeader: string;
  tabFormSx: SxProps<Theme>;
  sectionSx: SxProps<Theme>;
  sectionTitleSx: SxProps<Theme>;
  programId: ProgramNames | null | undefined;
  onSelectPrimaryContact: (id: number, contact?: ContactProps) => void;
  onShippingAddressChange: (address: AddressProps) => void;
  onMarkDirty: () => void;
};

export function ContactsTab({
  active,
  theme,
  programId,
  userType,
  selectedContactId,
  contactOptions,
  contactsLoading,
  shippingContact,
  shippingContactType,
  showErrors,
  shippingHeader,
  tabFormSx,
  sectionSx,
  sectionTitleSx,
  onSelectPrimaryContact,
  onShippingAddressChange,
  onMarkDirty,
}: Props) {
  return (
    <Box sx={{ ...(active ? tabFormSx : { display: 'none' }) }}>
      <Box sx={sectionSx}>
        <Typography variant='h6' sx={sectionTitleSx}>
          Primary Contact
        </Typography>
        <PrimaryContactSelect
          theme={theme}
          value={selectedContactId}
          options={contactOptions}
          loading={contactsLoading}
          disabled={userType !== UserType.Adf}
          onChange={(id, contact) => {
            onSelectPrimaryContact(id, contact);
            onMarkDirty();
          }}
        />
      </Box>

      {programId !== ProgramNames.TreeCitiesWorld && (
        <Box sx={sectionSx}>
          <Typography variant='h6' sx={sectionTitleSx}>
            {shippingHeader}
          </Typography>

          <ShippingAddressSection
            shippingContact={shippingContact}
            shippingContactType={shippingContactType}
            showErrors={showErrors}
            onChange={(address) => {
              onShippingAddressChange(address);
              onMarkDirty();
            }}
          />
        </Box>
      )}
    </Box>
  );
}
